module.exports = __webpack_public_path__ + "static/media/received_3579201952296323 (1).792f6d5d.jpeg";